export const BasicAddEditConfig = {
    scenarioFieldsModel: {
        scenarioID: '',
        scenarioName: '',
        scenarioType: 1,
        mappingType: 1,
        percentageType: 1,
        memo: '',
        sortIndex: 0,
        currencyBucket: 1,
        lastUpdateDate: '',
    },
    addEditScenarioFields: [
        {
            name: 'Scenario code',
            id: 'scenarioID',
            type: 'text',
            editable: false
        },
        {
            name: 'Scenario name',
            id: 'scenarioName',
            type: 'text',
            editable: true
        },
        {
            name: 'Scenario type',
            id: 'scenarioType',
            type: 'select',
            editable: false,
            options: [
                {
                    name: 'GLOBAL',
                    optionId: 'global',
                    id: 1
                },
                {
                    name: 'LOCAL',
                    optionId: 'local',
                    id: 2

                },
            ]
        },
        {
            name: 'Mapping type',
            id: 'mappingType',
            type: 'select',
            editable: true,
            options: [
                {
                    name: 'Rabobank GRM',
                    optionId: 'rabo-grm',
                    id: 1
                },
                {
                    name: 'Rabobank International',
                    optionId: 'rabo-intl',
                    id: 2

                },
                {
                    name: 'Rabobank Nederland',
                    optionId: 'rabo-nl',
                    id: 3
                },
            ]
        },
        {
            name: 'Percentage type',
            id: 'percentageType',
            type: 'select',
            editable: true,
            options: [
                { name: 'FIXED', optionId: 'fixed', id: 1 },
                { name: 'FLEXIBLE', optionId: 'flex', id: 2 }
            ]
        },
        {
            name: 'Scenario memo',
            id: 'memo',
            type: 'textarea',
            editable: true
        },
        {
            name: 'Sort index',
            id: 'sortIndex',
            type: 'number',
            editable: true
        },
        {
            name: 'Tagetik currency bucket',
            id: 'currencyBucket',
            type: 'select',
            editable: true,
            options: [
                { name: 'currency1', optionId: 'cur1', id: 1 },
                { name: 'currency2', optionId: 'cur2', id: 2 }
            ]
        },
        {
            name: 'Last updated',
            id: 'lastUpdateDate',
            type: 'text',
            editable: false
        },
    ]
}